import * as React from 'react';
import { AboutUsBody, AboutUsHeader, AboutUsSubtitle, AboutUsReview } from './styled';
import VerticalSpacer from '../VerticalSpacer';
import withCountryCode from '../../components/RoutesHoc/RoutesHoc';
import { reviews } from '../../helpers/routes';
import Link from '../Link/Link';

const AboutUsWelcome: React.ComponentType<{
  buildUrlWithCountry: (route: string) => string;
}> = ({ buildUrlWithCountry }) => (
  <div>
    <AboutUsHeader>What insiders are saying</AboutUsHeader>
    <VerticalSpacer height="20px" />
    <AboutUsBody>
      <AboutUsSubtitle>My new favorite!</AboutUsSubtitle>
      <VerticalSpacer height="20px" />
      <AboutUsReview>
        “If you are a seasoned Italian designer shopper and know your size, you are in for a pleasant surprise. I love
        love love my new Valentino Dollybow sandals. This won't be my last purchase.” – Susan H.
      </AboutUsReview>
      <br />
      <br />
      Read more reviews from italist insiders <Link href={buildUrlWithCountry(reviews)}>here</Link>.
    </AboutUsBody>
  </div>
);

export default withCountryCode(AboutUsWelcome);
